import { create } from "zustand"
import { type ConnectionState, SyncClient } from "twilio-sync"
import type {
  TAccount,
  TCluster,
  TPreferences,
  TUserStatus,
} from "@/schemas/user.schema"
import { syncTabs } from "zustand-sync-tabs"

interface TSyncStore {
  status: ConnectionState
  userStatus?: TUserStatus
  account?: TAccount
  cluster?: TCluster
  userPreferences?: TPreferences
  _: {
    syncClient?: SyncClient
    initialization: {
      documents: {
        account?: boolean
        departmentStats?: boolean
        dialerList?: boolean
        intention?: boolean
        lastRing?: boolean
        liveCalls?: boolean
        paymentStatus?: boolean
        recentCalls?: boolean
        roster?: boolean
        smartView?: boolean
        userPreferences?: boolean
        userStats?: boolean
        userStatus?: boolean
        cluster?: boolean
      }
      maps: {
        contacts?: boolean
        smsHistories?: boolean
      }
    }
  }
}

interface TSyncStoreWithFunctions extends TSyncStore {
  setStatus: (status: ConnectionState) => void
}

const initialState: TSyncStore = {
  status: "disconnected",
  userStatus: undefined,
  account: undefined,
  cluster: undefined,
  userPreferences: undefined,
  _: {
    syncClient: undefined,
    initialization: {
      documents: {
        account: false,
        departmentStats: false,
        dialerList: false,
        intention: false,
        lastRing: false,
        liveCalls: false,
        paymentStatus: false,
        recentCalls: false,
        roster: false,
        smartView: false,
        userPreferences: false,
        userStats: false,
        userStatus: false,
        cluster: false,
      },
      maps: {
        contacts: false,
        smsHistories: false,
      },
    },
  },
}

export const useSyncStore = create<TSyncStoreWithFunctions>()((set) => ({
  ...initialState,
  setStatus: (status) => set(() => ({ status })),
}))
